module.exports = __webpack_public_path__ + "img/building1.7678be0f.jpg";